import { SET_ADBLOCK_DETECTED } from '../actionTypes';

export const setAdBlockDetected = (adBlockDetected: boolean): any => ({
  type: SET_ADBLOCK_DETECTED,
  adBlockDetected,
});
